// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__L6oag","resendInfoText":"OnGoingPaymentBox_resendInfoText__1t6Hv"};